import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { memo, useRef, useEffect } from "react";

function getBestAnswerData(selectedValue, selectedValueSrNo, currentSrNo) {
  if (typeof selectedValue === "string" && String(selectedValueSrNo) === String(currentSrNo)) {
    return selectedValue;
  }
  return sessionStorage.getItem(`descriptive_answer_${currentSrNo}`) || "";
}

const DescriptiveTypingAnswer = memo(
  ({ selectedValue, selectedValueSrNo, handleTypingChange, editorInstanceRef, currentSrNo }) => {
    const editorRef = useRef(null);

    // Prevents onChange from firing when setData() is called programmatically
    const isProgrammaticRef = useRef(false);

    // Lets onReady read the latest values even if CKEditor re-invokes onReady
    // with a stale closure (e.g. React StrictMode's double-invoke in dev).
    const selectedValueRef = useRef(selectedValue);
    selectedValueRef.current = selectedValue;
    const selectedValueSrNoRef = useRef(selectedValueSrNo);
    selectedValueSrNoRef.current = selectedValueSrNo;

    useEffect(() => {
      if (!editorRef.current) return;
      const editableEl = editorRef.current.ui?.view?.editable?.element;
      const isFocused = editableEl && editableEl.contains(document.activeElement);
      if (isFocused) return;
      const currentData = editorRef.current.getData();
      const finalData = getBestAnswerData(selectedValue, selectedValueSrNo, currentSrNo);

      if (currentData !== finalData) {
        isProgrammaticRef.current = true;
        editorRef.current.setData(finalData);
      }
    }, [selectedValue, selectedValueSrNo, currentSrNo]);

    return (
      <div style={{ minHeight: "140px" }}>
        <CKEditor
          editor={ClassicEditor}
          config={{
            toolbar: [
              "heading",
              "|",
              "bold",
              "italic",
              "|",
              "bulletedList",
              "numberedList",
              "|",
              "insertTable",
              "|",
              "undo",
              "redo",
            ],
            table: {
              contentToolbar: [
                "tableColumn",
                "tableRow",
                "mergeTableCells",
              ],
            },
          }}
          onReady={(editor) => {
            editorRef.current = editor;
            editorInstanceRef.current = editor;

            isProgrammaticRef.current = true;
            editor.setData(getBestAnswerData(selectedValueRef.current, selectedValueSrNoRef.current, currentSrNo));
          }}
          onChange={(_event, editor) => {
            if (isProgrammaticRef.current) {
              isProgrammaticRef.current = false;
              return;
            }
            handleTypingChange(editor.getData());
          }}
        />
      </div>
    );
  }
);

export default DescriptiveTypingAnswer;
